<template>
	<div class="plannings">
		<div class="plannings__header">
			<h1 class="plannings__header__title">
				<i class="link__icon__element fas fa-clipboard-check"></i>
				<span class="plannings__header__title--faint">Your</span> plannings
			</h1>
			<router-link tag="button" class="plannings__create" :to="`/planning/edit`">
				<i class="fas fa-plus-circle"></i>
				Create planning
			</router-link>
		</div>
		<div class="plannings__content">
			<PlanningGrid :plannings="plannings"></PlanningGrid>
		</div>
	</div>
</template>

<script>
import PlanningGrid from '@/components/PlanningGrid.vue'
export default {
	data () {
		return {
		}
	},
	components: {
		PlanningGrid
	},
	methods: {
	},
	computed: {
		plannings () {
			return this.$store.state.plannings
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/views/_plannings.scss";
</style>
